import { Theme } from '@mui/material/styles';
import { tabClasses } from '@mui/material/Tab';

// ----------------------------------------------------------------------

export function tabs(theme: Theme) {
  return {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: theme.palette.primary.dark,
        },
        scrollButtons: {
          borderRadius: '40%',
          [`&:first-of-type.${tabClasses.disabled}`]: {
            display: 'none',
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        text: {
          color: theme.palette.primary.dark,
        },
        root: {
          color: theme.palette.primary.dark,
          padding: 0,
          opacity: 1,
          minWidth: 48,
          minHeight: 48,
          fontWeight: theme.typography.fontWeightSemiBold,
          '&:not(:last-of-type)': {
            marginRight: theme.spacing(3),
            [theme.breakpoints.up('sm')]: {
              marginRight: theme.spacing(5),
            },
          },
          [`&:not(.${tabClasses.selected})`]: {
            color: theme.palette.text.secondary,
          },
        },
      },
    },
  };
}
